import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import './DataPage.css';

const TIPOS = [
  { value: 'normal', label: 'Normal', color: '#1976d2' },
  { value: 'reenvio', label: 'Reenvio', color: '#ed6c02' },
  { value: 'notificacao_pagamento', label: 'Pagamento', color: '#9c27b0' },
  { value: 'sequencia', label: 'Sequência', color: '#2e7d32' },
  { value: 'sistema_abertura', label: 'Sistema', color: '#757575' },
  { value: 'resposta_botao_pix', label: 'PIX', color: '#00897b' },
  { value: 'followup_ia', label: 'Follow-up IA', color: '#5e35b1' },
];

const STATUS = [
  { value: 'enviado', label: 'Enviado', icon: '📤', color: '#1976d2' },
  { value: 'entregue', label: 'Entregue', icon: '✅', color: '#2e7d32' },
  { value: 'lido', label: 'Lido', icon: '👁️', color: '#00695c' },
  { value: 'erro', label: 'Erro', icon: '❌', color: '#c62828' },
];

const TIPO_MAP = TIPOS.reduce((acc, t) => { acc[t.value] = t; return acc; }, {});
const STATUS_MAP = STATUS.reduce((acc, s) => { acc[s.value] = s; return acc; }, {});

const fmtDateTime = (d) => {
  if (!d) return '';
  try { return new Date(d).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }); }
  catch { return String(d); }
};

function WhatsAppHistorico() {
  const hoje = new Date().toISOString().slice(0, 10);
  const semanaPassada = new Date(Date.now() - 7 * 24 * 3600 * 1000).toISOString().slice(0, 10);

  const [filtros, setFiltros] = useState({
    dataInicio: semanaPassada,
    dataFim: hoje,
    tipos: [],
    status: [],
    templateNome: '',
    busca: '',
  });
  const [page, setPage] = useState(1);
  const [pageSize] = useState(50);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 50, total: 0, totalPages: 0 });
  const [loading, setLoading] = useState(false);
  const [expandedId, setExpandedId] = useState(null);
  const [detalhes, setDetalhes] = useState({}); // { envioId: detalhesObj }
  const [cadeia, setCadeia] = useState({}); // { envioId: cadeiaObj }

  const carregar = useCallback(async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (filtros.dataInicio) params.set('dataInicio', filtros.dataInicio);
      if (filtros.dataFim) params.set('dataFim', filtros.dataFim);
      if (filtros.tipos.length) params.set('tipos', filtros.tipos.join(','));
      if (filtros.status.length) params.set('status', filtros.status.join(','));
      if (filtros.templateNome) params.set('templateNome', filtros.templateNome);
      if (filtros.busca) params.set('busca', filtros.busca);
      params.set('page', page);
      params.set('pageSize', pageSize);

      const res = await axios.get(`${API_URL}/whatsapp/envios/historico?${params}`);
      setData(res.data.data || []);
      setPagination(res.data.pagination || {});
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [filtros, page, pageSize]);

  useEffect(() => { carregar(); }, [carregar]);

  const toggleTipo = (v) => {
    setFiltros(f => ({ ...f, tipos: f.tipos.includes(v) ? f.tipos.filter(x => x !== v) : [...f.tipos, v] }));
    setPage(1);
  };
  const toggleStatus = (v) => {
    setFiltros(f => ({ ...f, status: f.status.includes(v) ? f.status.filter(x => x !== v) : [...f.status, v] }));
    setPage(1);
  };

  const expandir = async (envio) => {
    if (expandedId === envio.id) {
      setExpandedId(null);
      return;
    }
    setExpandedId(envio.id);

    // Carrega detalhes se ainda não tem
    if (!detalhes[envio.id]) {
      try {
        const res = await axios.get(`${API_URL}/whatsapp/envios/${envio.id}/detalhes`);
        setDetalhes(d => ({ ...d, [envio.id]: res.data }));
      } catch (err) { console.error(err); }
    }
    // Carrega cadeia se tem solicitacao_id
    if (envio.solicitacao_id && !cadeia[envio.id]) {
      try {
        const res = await axios.get(`${API_URL}/whatsapp/envios/sol/${envio.solicitacao_id}/cadeia`);
        setCadeia(c => ({ ...c, [envio.id]: res.data }));
      } catch (err) { console.error(err); }
    }
  };

  const exportarCsv = () => {
    const params = new URLSearchParams();
    if (filtros.dataInicio) params.set('dataInicio', filtros.dataInicio);
    if (filtros.dataFim) params.set('dataFim', filtros.dataFim);
    if (filtros.tipos.length) params.set('tipos', filtros.tipos.join(','));
    if (filtros.status.length) params.set('status', filtros.status.join(','));
    if (filtros.templateNome) params.set('templateNome', filtros.templateNome);
    if (filtros.busca) params.set('busca', filtros.busca);
    const token = localStorage.getItem('token');
    params.set('_token', token);
    // Browser precisa enviar Authorization — como não dá em download direto, abre em nova aba com POST disfarçado
    axios.get(`${API_URL}/whatsapp/envios/historico/export.csv?${params}`, { responseType: 'blob' })
      .then(res => {
        const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `historico-${hoje}.csv`;
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch(err => console.error('Erro CSV:', err));
  };

  return (
    <div className="data-page" style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>📜 Histórico de Envios</h1>
          <p style={{ margin: '4px 0 0 0', color: '#666', fontSize: 13 }}>
            {pagination.total ? `${pagination.total.toLocaleString('pt-BR')} envios encontrados` : 'Filtre e explore a timeline completa de cada paciente'}
          </p>
        </div>
        <button onClick={exportarCsv} style={btnSecondary}>⬇ Exportar CSV</button>
      </div>

      {/* Filtros */}
      <div style={cardStyle}>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end', marginBottom: 12 }}>
          <div style={fieldStyle}>
            <label style={labelStyle}>Data início</label>
            <input type="date" value={filtros.dataInicio} onChange={e => { setFiltros(f => ({ ...f, dataInicio: e.target.value })); setPage(1); }} style={inputStyle} />
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Data fim</label>
            <input type="date" value={filtros.dataFim} onChange={e => { setFiltros(f => ({ ...f, dataFim: e.target.value })); setPage(1); }} style={inputStyle} />
          </div>
          <div style={{ ...fieldStyle, flex: 1, minWidth: 240 }}>
            <label style={labelStyle}>Busca (paciente / telefone / protocolo)</label>
            <input type="text" value={filtros.busca} onChange={e => setFiltros(f => ({ ...f, busca: e.target.value }))}
              onKeyDown={e => e.key === 'Enter' && setPage(1) && carregar()}
              placeholder="Ex: RAFAEL, 553791265314, 263730" style={inputStyle} />
          </div>
          <div style={fieldStyle}>
            <label style={labelStyle}>Template</label>
            <input type="text" value={filtros.templateNome} onChange={e => setFiltros(f => ({ ...f, templateNome: e.target.value }))}
              placeholder="Ex: seu_exame_" style={{ ...inputStyle, width: 160 }} />
          </div>
        </div>

        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 8 }}>
          <div>
            <div style={labelStyle}>Tipo de envio</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {TIPOS.map(t => (
                <button key={t.value} onClick={() => toggleTipo(t.value)}
                  style={chipStyle(filtros.tipos.includes(t.value), t.color)}>
                  {t.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div style={labelStyle}>Status</div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {STATUS.map(s => (
                <button key={s.value} onClick={() => toggleStatus(s.value)}
                  style={chipStyle(filtros.status.includes(s.value), s.color)}>
                  {s.icon} {s.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Tabela */}
      <div style={cardStyle}>
        {loading ? (
          <div style={{ padding: 32, textAlign: 'center', color: '#999' }}>Carregando...</div>
        ) : data.length === 0 ? (
          <div style={{ padding: 32, textAlign: 'center', color: '#999' }}>Nenhum envio encontrado com os filtros atuais</div>
        ) : (
          <table style={tableStyle}>
            <thead>
              <tr style={{ background: '#f5f5f5', borderBottom: '2px solid #e0e0e0' }}>
                <th style={thStyle}>Data/Hora</th>
                <th style={thStyle}>Protocolo</th>
                <th style={thStyle}>Paciente</th>
                <th style={thStyle}>Tipo</th>
                <th style={thStyle}>Template</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}></th>
              </tr>
            </thead>
            <tbody>
              {data.map(envio => {
                const tipo = TIPO_MAP[envio.tipo_envio] || { label: envio.tipo_envio, color: '#666' };
                const st = STATUS_MAP[envio.status] || { label: envio.status, icon: '•', color: '#666' };
                const isExpanded = expandedId === envio.id;
                const det = detalhes[envio.id];
                const cad = cadeia[envio.id];

                return (
                  <React.Fragment key={envio.id}>
                    <tr style={{ borderBottom: '1px solid #eee', cursor: 'pointer', background: isExpanded ? '#f9fafb' : 'transparent' }}
                      onClick={() => expandir(envio)}>
                      <td style={tdStyle}><small style={{ color: '#666' }}>{fmtDateTime(envio.enviado_em)}</small></td>
                      <td style={tdStyle}>{envio.solicitacao_id || '—'}</td>
                      <td style={tdStyle}>
                        <div style={{ fontWeight: 500 }}>{envio.paciente_nome || '—'}</div>
                        <small style={{ color: '#888' }}>{envio.telefone}</small>
                      </td>
                      <td style={tdStyle}>
                        <span style={{ ...badgeStyle, background: tipo.color + '20', color: tipo.color, borderColor: tipo.color + '40' }}>{tipo.label}</span>
                      </td>
                      <td style={tdStyle}><small>{envio.template_nome || '—'}</small></td>
                      <td style={tdStyle}>
                        <span style={{ ...badgeStyle, background: st.color + '20', color: st.color, borderColor: st.color + '40' }}>
                          {st.icon} {st.label}
                        </span>
                      </td>
                      <td style={{ ...tdStyle, textAlign: 'right' }}>
                        <span style={{ color: '#1976d2', fontSize: 18 }}>{isExpanded ? '▾' : '▸'}</span>
                      </td>
                    </tr>
                    {isExpanded && (
                      <tr>
                        <td colSpan={7} style={{ background: '#f9fafb', padding: 16, borderBottom: '1px solid #eee' }}>
                          {det ? (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                              <div>
                                <div style={detalheSection}>📄 Mensagem completa</div>
                                <pre style={preStyle}>{det.mensagem_texto || '(vazio)'}</pre>
                                {det.erro && (
                                  <>
                                    <div style={{ ...detalheSection, color: '#c62828', marginTop: 12 }}>⚠️ Erro</div>
                                    <pre style={{ ...preStyle, background: '#fff3f3', color: '#c62828' }}>{det.erro}</pre>
                                  </>
                                )}
                                {det.variaveis && (
                                  <>
                                    <div style={{ ...detalheSection, marginTop: 12 }}>🔧 Variáveis</div>
                                    <pre style={preStyle}>{typeof det.variaveis === 'string' ? det.variaveis : JSON.stringify(det.variaveis, null, 2)}</pre>
                                  </>
                                )}
                              </div>
                              <div>
                                {envio.tem_snapshot && det.exames_snapshot && (
                                  <>
                                    <div style={detalheSection}>📋 Snapshot no momento do envio</div>
                                    <SnapshotView snapshot={det.exames_snapshot} />
                                  </>
                                )}
                                {cad && (
                                  <>
                                    <div style={{ ...detalheSection, marginTop: 16 }}>⏱️ Timeline da solicitação</div>
                                    <Timeline timeline={cad.timeline} />
                                  </>
                                )}
                              </div>
                            </div>
                          ) : <div style={{ padding: 12 }}>Carregando detalhes...</div>}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        )}

        {/* Paginação */}
        {pagination.totalPages > 1 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 12, borderTop: '1px solid #eee' }}>
            <small style={{ color: '#666' }}>
              Página {pagination.page} de {pagination.totalPages} · {pagination.total.toLocaleString('pt-BR')} envios
            </small>
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={() => setPage(1)} disabled={page === 1} style={btnPageDisabled(page === 1)}>«</button>
              <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} style={btnPageDisabled(page === 1)}>‹ anterior</button>
              <button onClick={() => setPage(p => Math.min(pagination.totalPages, p + 1))} disabled={page === pagination.totalPages} style={btnPageDisabled(page === pagination.totalPages)}>próxima ›</button>
              <button onClick={() => setPage(pagination.totalPages)} disabled={page === pagination.totalPages} style={btnPageDisabled(page === pagination.totalPages)}>»</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function SnapshotView({ snapshot }) {
  let parsed = snapshot;
  if (typeof snapshot === 'string') {
    try { parsed = JSON.parse(snapshot); } catch { return <pre style={preStyle}>{snapshot}</pre>; }
  }
  if (!parsed?.exames) return <pre style={preStyle}>{JSON.stringify(parsed, null, 2)}</pre>;

  return (
    <div style={{ fontSize: 12 }}>
      <div style={{ marginBottom: 8, color: '#666' }}>
        {parsed.total_exames} exames · {parsed.exames_prontos} prontos ({parsed.percentual_prontos}%)
      </div>
      <div style={{ maxHeight: 240, overflowY: 'auto', border: '1px solid #eee', borderRadius: 4 }}>
        <table style={{ width: '100%', fontSize: 12 }}>
          <thead>
            <tr style={{ background: '#f5f5f5' }}>
              <th style={{ ...thStyle, fontSize: 11, padding: 6 }}>Exame</th>
              <th style={{ ...thStyle, fontSize: 11, padding: 6 }}>Situação</th>
              <th style={{ ...thStyle, fontSize: 11, padding: 6 }}>Resultado</th>
            </tr>
          </thead>
          <tbody>
            {parsed.exames.map(e => {
              const pronto = ['F','D','L','I','E','A'].includes((e.situacao || '').trim());
              return (
                <tr key={e.exame}>
                  <td style={{ padding: 6, borderBottom: '1px solid #f0f0f0' }}>{e.exame_nome || e.exame}</td>
                  <td style={{ padding: 6, borderBottom: '1px solid #f0f0f0' }}>
                    <span style={{ color: pronto ? '#2e7d32' : '#ed6c02' }}>{pronto ? '✅' : '⏳'} {e.situacao}</span>
                  </td>
                  <td style={{ padding: 6, borderBottom: '1px solid #f0f0f0', color: '#666' }}>
                    {e.tem_resultado ? 'Sim' : '—'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Timeline({ timeline }) {
  if (!timeline || !timeline.length) return <div style={{ fontSize: 12, color: '#999' }}>Sem eventos</div>;
  return (
    <div style={{ fontSize: 12 }}>
      {timeline.map((ev, i) => {
        const isIncoming = ev.tipo_evento === 'incoming';
        const tipo = TIPO_MAP[ev.tipo_envio] || {};
        return (
          <div key={i} style={{ display: 'flex', gap: 8, padding: '4px 0', borderBottom: '1px dashed #eee' }}>
            <div style={{ color: '#888', whiteSpace: 'nowrap', minWidth: 130 }}>
              {fmtDateTime(ev.ts)}
            </div>
            <div>
              {isIncoming ? (
                <><span style={{ color: '#2e7d32' }}>⬅ incoming</span> <span style={{ color: '#666' }}>({ev.tipo})</span> <em>{ev.body ? ev.body.substring(0, 60) : ''}</em></>
              ) : (
                <><span style={{ color: tipo.color || '#666' }}>➡ {ev.tipo_envio}</span> <span style={{ color: '#666' }}>{ev.template_nome || ''}</span> · <span style={{ fontSize: 11, color: '#888' }}>{ev.status}</span></>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

const cardStyle = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.08)', marginBottom: 16 };
const fieldStyle = { display: 'flex', flexDirection: 'column', gap: 4 };
const labelStyle = { fontSize: 11, fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', marginBottom: 4, display: 'block' };
const inputStyle = { padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 4, fontSize: 13, boxSizing: 'border-box' };
const tableStyle = { width: '100%', borderCollapse: 'collapse', fontSize: 13 };
const thStyle = { padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#374151', fontSize: 12, textTransform: 'uppercase', letterSpacing: '.3px' };
const tdStyle = { padding: '10px 12px', verticalAlign: 'top' };
const badgeStyle = { display: 'inline-block', padding: '2px 8px', borderRadius: 10, fontSize: 11, fontWeight: 600, border: '1px solid' };
const detalheSection = { fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '.3px' };
const preStyle = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 4, padding: 8, fontSize: 11, whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: 220, overflowY: 'auto' };
const btnSecondary = { background: '#fff', border: '1px solid #1976d2', color: '#1976d2', padding: '7px 14px', borderRadius: 4, fontSize: 13, cursor: 'pointer', fontWeight: 600 };
const chipStyle = (active, color) => ({
  padding: '5px 11px', borderRadius: 14, fontSize: 12, fontWeight: 500, cursor: 'pointer',
  background: active ? color : '#fff', color: active ? '#fff' : color,
  border: `1px solid ${color}`,
});
const btnPageDisabled = (disabled) => ({
  padding: '6px 12px', border: '1px solid #d1d5db', background: disabled ? '#f5f5f5' : '#fff',
  color: disabled ? '#aaa' : '#333', borderRadius: 4, cursor: disabled ? 'not-allowed' : 'pointer', fontSize: 12,
});

export default WhatsAppHistorico;
